module.exports = __webpack_public_path__ + "static/img/2.6e8a22b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/2020.2.27/2.jpg
// module id = h9mV
// module chunks = 1